import { render } from "./Attachment.vue?vue&type=template&id=3b7335bc&scoped=true"
import script from "./Attachment.vue?vue&type=script&lang=js"
export * from "./Attachment.vue?vue&type=script&lang=js"

import "./Attachment.vue?vue&type=style&index=0&id=3b7335bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b7335bc"]])

export default __exports__